/* eslint-disable max-len */
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { Injector, inject } from '@angular/core';
import { catchError, from, switchMap, throwError } from 'rxjs';
import { AlertService } from '../services/alert.service';
import { AuthService } from '../services/auth.service';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const alertService = inject(AlertService);
  const injector = inject(Injector);
  let retryCount = 0;

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const errorData = error.error;
      const code = errorData?.code || errorData?.statusCode;

      if (errorData && code === 401 && retryCount < 1) {
        retryCount++;
        // If error is 401 Unauthorized, try refreshing the session
        return from(injector.get(AuthService).updateSession()).pipe(
          switchMap(() => {
            retryCount = 0;
            const token = localStorage.getItem('accessToken');
            const authReq = req.clone({ setHeaders: { Authorization: `Bearer ${token}` } });
            return next(authReq);
          })
        );
      }

      if (code === 401) {
        inject(AuthService).logout();
        alertService.showModal({
          title: 'Sesión Expirada',
          text: 'Tu sesión ha expirado, por favor inicia sesión nuevamente',
        });
        return throwError(() => error);
      }

      if (errorData) {
        const message = getErrorMessage(errorData.error);

        alertService.showModal({
          title: 'Error',
          html: message || 'Ha ocurrido un error inesperado',
        });
      } else {
        alertService.showModal({
          title: 'Error',
          text:
            error.error?.message ||
            error.message ||
            'Ha ocurrido un error inesperado',
        });
      }

      return throwError(() => error);
    })
  );
};

const errorMessages: { [key: string]: string } = {
  'PSW-001': `<div class='flex flex-col gap-2'><p>Usuario o contraseña incorrectos. Por favor, inténtalo de nuevo.</p><span class='text-sm text-slate-500 self-end'>Código: PSW-001</span></div>`,
  'PSW-002': `<div class='flex flex-col gap-2'><p>Error al actualizar tu sesión. Por favor, inicia sesión nuevamente.</p><span class='text-sm text-slate-500 self-end'>Código: PSW-002</span></div>`,
  'PSW-003': `<div class='flex flex-col gap-2'><p>Usuario inactivo. Contacta con tu supervisor.</p><span class='text-sm text-slate-500 self-end'>Código: PSW-003</span></div>`,
  'VPV-001': `<div class='flex flex-col gap-2'><p>Existen campos sin validar, no se puede guardar la validación preventa.</p><span class='text-sm text-slate-500 self-end'>Código: VPV-001</span></div>`,
  'VPV-002': `<div class='flex flex-col gap-2'><p>La venta ya tiene servicios asociados y no es posible realizar la validación preventa nuevamente.</p><span class='text-sm text-slate-500 self-end'>Código: VPV-002</span></div>`,
  'VPV-003': `<div class='flex flex-col gap-2'><p>Esta venta no tiene servicios en estado SIN VALIDAR, no se puede realizar la validación preventa.</p><span class='text-sm text-slate-500 self-end'>Código: VPV-003</span></div>`,
  'VPV-004': `<div class='flex flex-col gap-2'><p>Existen campos sin validar en los servicios asociados, no se puede guardar la validación preventa.</p><span class='text-sm text-slate-500 self-end'>Código: VPV-004</span></div>`,
  'CED-001': `<div class='flex flex-col gap-2'><p>El usuario seleccionado para la cuenta de TV ya se encuentra en uso por otro usuario.</p><span class='text-sm text-slate-500 self-end'>Código: CED-001</span></div>`,
};

function getErrorMessage(errorCode: string) {
  return errorMessages[errorCode] || errorCode;
}
